<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
     class="d-flex flex-column w-100 overflow-y-auto overflow-x-hidden no-scroll-bar background-white">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row m-0 p-2 background-primary-blue height-70px shadow z-max align-items-center">
        <div (click)="back()" class="col-2 pt-4 pb-4 btn text-reset d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-chevron-left fa-xl"></i>
        </div>
        <div class="col-8 m-auto row d-flex justify-content-center align-items-center">
            @if (!farmStore.loading()) {
                <div class="col-8 fs-main text-center color-white">Farms ({{ farmStore.farm()?.name }})</div>
            }
            <div class="col-4 d-flex justify-content-center align-items-center">
        <span><app-homestead-svg [colored]="true"
                                 [height]="'20px'"
                                 [width]="'20px'"
                                 class="img-fluid img-max m-auto"></app-homestead-svg></span>
                <span class="color-white ms-1"> {{ farmReferences.length }}</span>
            </div>
        </div>
        <div (click)="close()" class="pointer text-reset col-2 d-flex justify-content-center align-items-center">
            <i class="color-white fa-solid fa-x fa-xl"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div class="input-group position-relative mb-2">
            <input (input)="filterResults($event.target)"
                   class="form-control m-auto rounded-pill height-50px ps-3 pe-3"
                   placeholder="Search..."
                   style="padding-right: 30px;"
                   type="search">
            <i class="fa-solid fa-magnifying-glass"
               style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); pointer-events: none;"></i>
        </div>
        <div class="flex-grow-1">
            @for (farm of filteredFarmReferences; track farm.id) {
                <div class="mb-2 background-light-gray rounded-2">
                    <div (click)="focusOnFarm(farm)" class="row pointer pointer-hover-blue m-0 p-2 rounded-2">
                        <div class="col-2 d-flex justify-content-center">
                            <app-homestead-svg [colored]="true" class="img-fluid img-max m-auto"></app-homestead-svg>
                        </div>
                        <div class="col-10 d-flex justify-content-start">
                            <div class="fw-bold text-truncate mt-auto mb-auto">{{ farm?.label || '-' }}</div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>